import React, { useContext } from "react";
import { FiTrendingUp, FiUserCheck, FiUsers, FiUserX } from "react-icons/fi";
import SummaryCard from "../../../components/common/SummaryCard";
import { ServiceContext } from "../../../hooks/context/ServiceContext";
import ChartSection from "./ChartSection";
import { ClipLoader } from "react-spinners";
import { TbSum } from "react-icons/tb";

const Overview = ({
  data,
  isLoading,
  error,
  setAnalyticsChartFilter,
  selectedValues,
}: any) => {
  const { service: network } = useContext(ServiceContext);
  const summary = data?.data || {};
console.log("Overview Data:", data);
  return (
    <div>
      {network === "mtn" ? (
        <div className="grid-c4 mt-7">
          <SummaryCard
            className=""
            titleHeading="DAU"
            totalHeading={summary?.dau?.value ?? 0}
            isIcon
            icon={FiUsers}
            showSections={false}
            change={summary?.dau?.change?.value ?? 0}
            isPositive={true}
          />
          <SummaryCard
            className=""
            titleHeading="WAU"
            totalHeading={summary?.wau?.value ?? 0}
            isIcon
            icon={FiUserCheck}
            showSections={false}
            change={summary?.wau?.change?.value ?? 0}
            isPositive={true}
          />
          <SummaryCard
            titleHeading="MAU"
            totalHeading={summary?.mau?.value ?? 0}
            isIcon
            icon={FiUserX}
            showSections={false}
            change={summary?.mau?.change?.value ?? 0}
            isPositive={true}
          />
          <SummaryCard
            titleHeading="Bounce Rate"
            totalHeading={`${summary?.bounceRate?.value ?? 0}%`}
            isIcon
            icon={FiTrendingUp}
            showSections={false}
            change={summary?.bounceRate?.change?.value ?? 0}
            isPositive={true}
          />
          <SummaryCard
            titleHeading="Avg Session"
            totalHeading={`${summary?.avgSessionDuration?.value ?? 0}%`}
            isIcon
            icon={TbSum}
            showSections={false}
            change={summary?.avgSessionDuration?.change?.value ?? 0}
            isPositive={true}
          />
          <SummaryCard
            titleHeading="Session Per User"
            totalHeading={`${summary?.sessionsPerUser?.value ?? 0}%`}
            isIcon
            icon={TbSum}
            showSections={false}
            change={summary?.sessionsPerUser?.change?.value ?? 0}
            isPositive={true}
          />
        </div>
      ) : (
        <div className="grid-c4 mt-7">
          <SummaryCard
            className=""
            titleHeading="DAU"
            totalHeading={summary?.dau?.value ?? 0}
            isIcon
            icon={FiUsers}
            showSections={false}
            change={summary?.dau?.change?.value ?? 0}
            isPositive={true}
          />
          <SummaryCard
            className=""
            titleHeading="WAU"
            totalHeading={summary?.wau?.value ?? 0}
            isIcon
            icon={FiUserCheck}
            showSections={false}
            change={summary?.wau?.change?.value ?? 0}
            isPositive={true}
          />
          <SummaryCard
            titleHeading="MAU"
            totalHeading={summary?.mau?.value ?? 0}
            isIcon
            icon={FiUserX}
            showSections={false}
            change={summary?.mau?.change?.value ?? 0}
            isPositive={true}
          />
          <SummaryCard
            titleHeading="Bounce Rate"
            totalHeading={`${summary?.bounceRate?.value ?? 0}%`}
            isIcon
            icon={FiTrendingUp}
            showSections={false}
            change={summary?.bounceRate?.change?.value ?? 0}
            isPositive={true}
          />
          <SummaryCard
            titleHeading="Avg Session"
            totalHeading={`${summary?.avgSessionDuration?.value ?? 0}%`}
            isIcon
            icon={TbSum}
            showSections={false}
            change={summary?.avgSessionDuration?.change?.value ?? 0}
            isPositive={true}
          />
           <SummaryCard
            titleHeading="Session Per User"
            totalHeading={`${summary?.sessionsPerUser?.value ?? 0}%`}
            isIcon
            icon={TbSum}
            showSections={false}
            change={summary?.sessionsPerUser?.change?.value ?? 0}
            isPositive={true}
          />
        </div>
      )}

      {/* Charts */}
      {isLoading ? (
        <div className="mt-10 flex justify-center items-center">
          <ClipLoader color="#071839" />
        </div>
      ) : error ? (
        <div className="mt-10 p-4 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-red-600 text-center">Error loading analytics data. Please try again.</p>
        </div>
      ) : (
        <div>
          <ChartSection
            selectedValues={selectedValues}
            chartData={data}
            // setAnalyticsChartFilter={setAnalyticsChartFilter}
          />
        </div>
      )}
    </div>
  );
};

export default Overview;
